
export const authRoutes = {
  userHome: "/dashboard",
  orgHome: (orgId: string) => `/org/${orgId}`,
  auth: {
    login: "/auth/login",
    signUp: "/auth/sign-up",
    forgotPassword: "/auth/forgot-password",
    updatePassword: "/auth/update-password",
    error: "/auth/error",
  },
};
